import { FlatpickrFn } from 'flatpickr/dist/types/instance'
import { CustomLocale } from 'flatpickr/dist/types/locale'

declare global {
  // tslint:disable-next-line
  interface Window {
    flatpickr: any
  }
}

const fp =
  typeof window !== 'undefined' && window.flatpickr !== undefined
    ? window.flatpickr
    : ({
        l10ns: {},
      } as FlatpickrFn)

export const HaitianCreole: CustomLocale = {
  weekdays: {
    shorthand: ['Dim', 'Len', 'Mad', 'Mèk', 'Jed', 'Van', 'Sam'],
    longhand: ['Dimanch', 'Lendi', 'Madi', 'Mèkredi', 'Jedi', 'Vandredi', 'Samdi'],
  },

  months: {
    shorthand: ['Jan', 'Fev', 'Mas', 'Avr', 'Me', 'Jem', 'Jiy', 'Out', 'Sep', 'Okt', 'Nov', 'Des'],
    longhand: [
      'Janvye',
      'Fevriye',
      'Mas',
      'Avril',
      'Me',
      'Jen',
      'Jiyè',
      'Out',
      'Septanm',
      'Oktòb',
      'Novanm',
      'Desanm',
    ],
  },

  ordinal: () => {
    return 'yèm'
  },

  firstDayOfWeek: 1,
  rangeSeparator: ' pou ',
  time_24hr: true,
}

export default fp.l10ns
